import { useTranslation } from "react-i18next";

export default function SafetySection() {
  const { t } = useTranslation("home");
  const items = t("safetyItems", { returnObjects: true }) as string[];

  return (
    <section className="bg-background-100 py-16 md:py-24 px-4 md:px-6">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 text-center mb-8">
          {t("safetyTitle")}
        </h2>

        <p className="text-sm md:text-base text-foreground-600 text-center max-w-2xl mx-auto leading-relaxed mb-10">
          {t("safetyDesc")}
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {items.map((item: string, i: number) => (
            <div
              key={i}
              className="flex flex-col items-center text-center p-6 bg-background-50 rounded-xl"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 mb-4">
                <i className="ri-shield-check-line text-accent-600 text-xl"></i>
              </div>
              <span className="text-sm font-medium text-foreground-800">
                {item}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}